"use client";

import { useLocale } from "@i18n/react";
import { useQueryClient } from "@tanstack/react-query";

import { useOpenApiQuery } from "../../../request/hooks/useOpenApiQuery";
import { keyFamily } from "./keyFamily";

export const useRequestFamily = () => {
  const queryClient = useQueryClient();
  const locale = useLocale();

  return {
    // GET /family
    query: useOpenApiQuery({
      urlBackendPath: "/family",
      queryKey: keyFamily(),
    }),
  };
};
